import { render, staticRenderFns } from "./ComponentCreate.vue?vue&type=template&id=99bcdcce&"
import script from "./ComponentCreate.vue?vue&type=script&lang=js&"
export * from "./ComponentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports